(function() {
    'use strict';

    module.exports = {
        setOneFrontVersionInLocalStorage: function() {
            var regex = /^(?:.)+\.([0-9]+)(?:.)+$/;
            var releaseNumber = regex.exec(Odigeo.SessionScope.oneFrontVersion);
            if (!Odigeo.Storage.get('one_front_version')) {
                Odigeo.Storage.set('one_front_version', Odigeo._.isArray(releaseNumber) && releaseNumber.length > 0 ?
                    releaseNumber[1] : Odigeo.SessionScope.oneFrontVersion);
            }
        },
        removeFromStorage: function(storeType, storeField) {
            Odigeo[storeType].remove(storeField);
        },
    };
}());
